import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style/index.scss"
import animated from "animate.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import permission from '@/directive/permission/index'
import { isPermission, itemDate, stage } from "@/utils";
// animate動畫
Vue.use(animated)
// elementUI
Vue.use(ElementUI);
// swiper輪播
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false;
Vue.directive('permission', permission)
Vue.prototype.$itemDate = itemDate
Vue.prototype.$stage = stage
Vue.prototype.$isPermission = isPermission
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
